import { types } from "../types/types"

export const saveLogin = (data) => {
    return {
        type: types.login,
        payload: data
    }
}